import { Fragment, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { Link } from "react-router-dom";
import { Label } from "reactstrap";
import { LI, UL } from "../../AbstractElements";
import LogoutClass from "../Header/RightBar/Logout";
import { MENUITEMS } from "./Menu";
import { hasMenuPermission } from "../../utils/hasmenupermission";
import permissionContext from "../../_helper/permissions";

const SidebarMenuItems = ({ setMainMenu, sidebartoogle, setNavActive }) => {
  const userData = JSON.parse(localStorage.getItem("user")) || {};

  const queryClient = useQueryClient();
  const data = queryClient.getQueryData("getProfile");

  const [activeItem, setActiveItem] = useState(null);

  const { t } = useTranslation();

  const { permissions: userPermissions } = useContext(permissionContext);

  const toggletNavActive = (item) => {
    setActiveItem(item);
    setMainMenu({ mainmenu: MENUITEMS });
  };

  const isParentActive = (menuItem) => {
    // parent itself active
    if (menuItem === activeItem) return true;

    // first level children
    if (menuItem.children) {
      return menuItem.children.some((child) => {
        // direct child active
        if (child === activeItem) return true;

        // nested child active
        if (child.children) {
          return child.children.some((subChild) => subChild === activeItem);
        }

        return false;
      });
    }

    return false;
  };

  return (
    <Fragment>
      <UL attrUL={{ className: "nav-menu custom-scrollbar" }}>
        <LI attrLI={{ className: "back-btn" }}>
          <div className="mobile-back text-end">
            <span>Back</span>
            <i className="fa fa-angle-right ps-2"></i>
          </div>
        </LI>

        {MENUITEMS.map((Item, i) => {
          const filteredItems = Item.Items.filter((menuItem) =>
            hasMenuPermission(userPermissions, menuItem.permission),
          );

          return (
            <Fragment key={i}>
              {filteredItems.map((menuItem, i) => (
                <LI key={i}>
                  {/* MAIN SUB MENU */}
                  {menuItem.type === "sub" && (
                    <a
                      href="javascript"
                      id="nav-link"
                      className={`nav-link menu-title ${
                        isParentActive(menuItem) ? "active-menu-tab" : ""
                      }`}
                      onClick={(event) => {
                        event.preventDefault();
                        toggletNavActive(menuItem);
                      }}
                    >
                      {menuItem.icon !== undefined && (
                        <menuItem.icon
                          color={isParentActive(menuItem) ? "#FFF" : "#616161"}
                        />
                      )}

                      <span>{t(menuItem.title)}</span>

                      <div className="according-menu">
                        {isParentActive(menuItem) ? (
                          <i className="fa fa-angle-down"></i>
                        ) : (
                          <i className="fa fa-angle-left"></i>
                        )}
                      </div>
                    </a>
                  )}

                  {/* MAIN LINK */}
                  {menuItem.type === "link" && (
                    <Link
                      to={menuItem.path}
                      id="nav-link"
                      className={`nav-link menu-title ${
                        menuItem === activeItem ? "active" : ""
                      }`}
                      onClick={() => toggletNavActive(menuItem)}
                    >
                      {menuItem.icon !== undefined && <menuItem.icon />}

                      <span>{t(menuItem.title)}</span>

                      {menuItem.title === "Tasks" && data && (
                        <span className="box">{userData.tasks}</span>
                      )}

                      {menuItem.badge && (
                        <Label className={menuItem.badge}>
                          {menuItem.badgetxt}
                        </Label>
                      )}
                    </Link>
                  )}

                  {/* CHILDREN */}
                  {menuItem.children && (
                    <UL
                      attrUL={{
                        className: "simple-list sidebar-submenu",
                      }}
                    >
                      <UL
                        attrUL={{
                          className: "nav-submenu menu-content",
                          style: isParentActive(menuItem)
                            ? sidebartoogle
                              ? {
                                  opacity: 1,
                                  transition: "opacity 500ms ease-in",
                                }
                              : { display: "block" }
                            : { display: "none" },
                        }}
                      >
                        {menuItem.children.map((childrenItem, index) => {
                          const isChildActive =
                            childrenItem === activeItem ||
                            childrenItem.children?.some(
                              (subChild) => subChild === activeItem,
                            );

                          return (
                            <LI key={index}>
                              {/* CHILD SUB */}
                              {childrenItem.type === "sub" && (
                                <a
                                  href="javascript"
                                  className={`${isChildActive ? "active" : ""}`}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    toggletNavActive(childrenItem);
                                  }}
                                >
                                  {t(childrenItem.title)}

                                  <div className="according-menu">
                                    {isChildActive ? (
                                      <i className="fa fa-caret-down"></i>
                                    ) : (
                                      <i className="fa fa-caret-right"></i>
                                    )}
                                  </div>
                                </a>
                              )}

                              {/* CHILD LINK */}
                              {childrenItem.type === "link" && (
                                <Link
                                  to={childrenItem.path}
                                  className={`${
                                    childrenItem === activeItem ? "active" : ""
                                  }`}
                                  onClick={() => toggletNavActive(childrenItem)}
                                >
                                  {t(childrenItem.title)}

                                  {childrenItem.icon !== undefined && (
                                    <childrenItem.icon className="ms-2" />
                                  )}
                                </Link>
                              )}

                              {/* SUB CHILDREN */}
                              {childrenItem.children && (
                                <UL
                                  attrUL={{
                                    className:
                                      "simple-list nav-sub-childmenu submenu-content",
                                    style: isChildActive
                                      ? {
                                          display: "block",
                                        }
                                      : {
                                          display: "none",
                                        },
                                  }}
                                >
                                  {childrenItem.children.map(
                                    (childrenSubItem, key) => (
                                      <LI key={key}>
                                        {childrenSubItem.type === "link" && (
                                          <Link
                                            to={childrenSubItem.path}
                                            className={`${
                                              childrenSubItem === activeItem
                                                ? "active"
                                                : ""
                                            }`}
                                            onClick={() =>
                                              toggletNavActive(childrenSubItem)
                                            }
                                          >
                                            {t(childrenSubItem.title)}
                                          </Link>
                                        )}
                                      </LI>
                                    ),
                                  )}
                                </UL>
                              )}
                            </LI>
                          );
                        })}
                      </UL>
                    </UL>
                  )}
                </LI>
              ))}
            </Fragment>
          );
        })}
      </UL>

      <LogoutClass />
    </Fragment>
  );
};

export default SidebarMenuItems;
